import { loadFeedbackContexts } from './feedbackV1';
import { createFetchRequestWithLocalisedError } from '../utils';

export async function fetchContexts(accessToken: string) {
  return createFetchRequestWithLocalisedError(() => loadFeedbackContexts(accessToken), 'localised-errors-feedback-fetch-error');
}
